export default "__VITE_ASSET__1f8d45ff__"